const Airtable = require("airtable");

/**
  * Store Data to the Airtable Base
  * @params {string} baseName name of the Airtable base
  * @params {array} Array of fields for particular base

  *  @returns {string} New array of data
*/
export function storeDataToBase(baseName, fields) {
  const { VUE_APP_AIRTABLE_API_KEY, VUE_APP_BASE_ID } = process.env;

  const data = [];
  var base = new Airtable({ apiKey: VUE_APP_AIRTABLE_API_KEY }).base(
    VUE_APP_BASE_ID
  );

  base(baseName).create(fields, function(err, records) {
    if (err) {
      console.error(err);
      return;
    }
    records.forEach(function(record) {
      data.push(record.fields);
    });
  });
  return data;
}
